import { render, staticRenderFns } from "./AditivoApostilaView.vue?vue&type=template&id=3cc9c009&scoped=true"
import script from "./AditivoApostilaView.vue?vue&type=script&lang=js"
export * from "./AditivoApostilaView.vue?vue&type=script&lang=js"
import style0 from "./AditivoApostilaView.vue?vue&type=style&index=0&id=3cc9c009&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9c009",
  null
  
)

export default component.exports